import { useTranslation } from 'react-i18next'

export function LanguageSelector() {
    const { i18n } = useTranslation()

    const toggleLanguage = (lng: string) => {
        i18n.changeLanguage(lng)
    }

    const currentLanguage = i18n.language.split('-')[0] // Handle codes like 'en-US'

    return (
        <div className="flex bg-gray-100 dark:bg-gray-800 rounded-lg p-1 border border-gray-200 dark:border-gray-700 shadow-sm transition-[border-color,box-shadow] duration-200">
            <button
                onClick={() => toggleLanguage('en')}
                className={`px-2 py-1 text-xs font-bold rounded-md transition-colors duration-200 ${currentLanguage === 'en'
                    ? 'bg-white dark:bg-gray-700 text-blue-600 dark:text-blue-400 shadow-sm'
                    : 'text-gray-400 hover:text-gray-600 dark:hover:text-gray-300'}`}
            >
                EN
            </button>
            <button
                onClick={() => toggleLanguage('es')}
                className={`px-2 py-1 text-xs font-bold rounded-md transition-colors duration-200 ${currentLanguage === 'es'
                    ? 'bg-white dark:bg-gray-700 text-blue-600 dark:text-blue-400 shadow-sm'
                    : 'text-gray-400 hover:text-gray-600 dark:hover:text-gray-300'}`}
            >
                ES
            </button>
        </div>
    )
}
